//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UrlInput from './UrlInput'
import ConsoleButton from './ConsoleButton'
//
export default {
  name: 'DebugBlock',
  props: {
    position: {
      type: String,
      required: true,
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['top', 'bottom'].indexOf(value) !== -1
      }
    },
    testServer: { default: '' } // 测试服务器地址
  },
  components: { UrlInput, ConsoleButton },
  data () {
    return {
      isShowEntry: false, // 是否显示
      entryClickCnt: 0,
      entryClickTimer: null
    }
  },
  methods: {
    /*----------------------------------------- 自定义方法 -----------------------------------------*/

    /*----------------------------------------- 绑定方法 -----------------------------------------*/
    /*  隐藏按钮点击
      * */
    btnClick () {
      this.entryClickCnt++
      clearTimeout(this.entryClickTimer)
      this.entryClickTimer = setTimeout(() => {
        //要求2s内点击多次，否则不能进入调试
        this.entryClickCnt = 0
      }, 2000)
      if (this.entryClickCnt >= 5) {
        this.entryClickCnt = 0
        this.isShowEntry = true
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/items/DebugBlock/index.vue